import { createService } from '@betty/toolkit/api';
import {
  PaymentProvidersSchema,
  PaymentDetailsSchema,
  PaymentUrlSchema,
  TransactionStatusSchema,
  UnverifiedPaymentMethodsSchema,
  CheckInteracEmailSchema,
  SendInteracEmailSchema,
  ResendInteracEmailSchema,
  VerifyInteracEmailSchema,
  WithdrawalLimitsSchema,
  ApplePayDepositResponseSchema,
} from './PaymentService.schemas';

export default {
  ...createService(
    {
      getPaymentProviders: {
        method: 'GET',
        url: '/availablePaymentProviders',
        headers: {
          'allowed-providers-version': 'v2',
        },
        responseSchema: PaymentProvidersSchema,
      },
      getPaymentDetails: {
        method: 'GET',
        url: '/paymentDetails',
        responseSchema: PaymentDetailsSchema,
      },
      getPaymentUrl: {
        method: 'POST',
        url: ({ type }: { type: 'deposit' | 'withdrawal' }) => `/${type}launch`,
        responseSchema: PaymentUrlSchema,
      },
      getTransactionStatus: {
        method: 'GET',
        url: '/payments/transactionStatus',
        responseSchema: TransactionStatusSchema,
      },
      getUnverifiedPaymentMethods: {
        method: 'GET',
        url: '/unverifiedPaymentMethods',
        responseSchema: UnverifiedPaymentMethodsSchema,
      },
      checkInteracEmail: {
        method: 'POST',
        url: '/interac/emails/check',
        responseSchema: CheckInteracEmailSchema,
      },
      sendInteracEmail: {
        method: 'POST',
        url: '/interac/emails',
        responseSchema: SendInteracEmailSchema,
      },
      resendInteracEmail: {
        method: 'POST',
        url: '/interac/emails/resendLink',
        responseSchema: ResendInteracEmailSchema,
      },
      applePayDeposit: {
        method: 'POST',
        url: '/worldpay/applePayDeposit',
        responseSchema: ApplePayDepositResponseSchema,
      },
    },
    ({ userId }) => `/Players/${userId}`,
  ),
  ...createService({
    verifyInteracEmail: {
      method: 'POST',
      url: '/interac/emails/verify',
      responseSchema: VerifyInteracEmailSchema,
    },
    getWithdrawLimits: {
      method: 'GET',
      url: '/settings/withdrawal',
      responseSchema: WithdrawalLimitsSchema,
    },
  }),
};
